<template>
  <v-card flat>
    <v-flex xs12>
      <v-btn 
        flat 
        icon
        class="mr-0"
        :disabled="loading || !post.accept_interactions"
        :color="post.interaction_type === 'I like' ? 'blue Number-2' : 'grey lighten-1'" 
        @click="post.interaction_type === 'I like' ? handleDeleteReaction('I like') : handleCreateReaction('I like')"
      >
        <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/thumbs-up-solid.svg" class="icons-color-reactions" alt="">
      </v-btn>

      <span>{{ post.interactions.find(i => i.name === 'I like').total }}</span>

      <v-btn
        flat
        icon
        class="mr-0"
        :disabled="loading || !post.accept_interactions"
        :color="post.interaction_type === 'I love it' ? 'pink' : 'grey lighten-1'" 
        @click="post.interaction_type === 'I love it' ? handleDeleteReaction('I love it') : handleCreateReaction('I love it')"
      >
        <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/heart-solid.svg" class="icons-color-reactions" alt="">
      </v-btn>

      <span>{{ post.interactions.find(i => i.name === 'I love it').total }}</span>

      <v-btn 
        flat 
        icon
        small
        :disabled="loading || !post.accept_interactions"
        class="mr-0 ml-3"
        @click="post.interaction_type === 'I enjoy' ? handleDeleteReaction('I enjoy') : handleCreateReaction('I enjoy')"
      >
        <img src="@/assets/icon_enjoy.svg" style="height: 1.6rem" v-if="post.interaction_type === 'I enjoy'">
        <img src="@/assets/icon_enjoy_outlined.svg" style="height: 1.6rem" v-else>
      </v-btn>

      <span>{{ post.interactions.find(i => i.name === 'I enjoy').total }}</span>

      <v-btn 
        flat 
        icon
        small
        :disabled="loading || !post.accept_interactions"
        class="mr-0 ml-3"
        @click="post.interaction_type === 'I surprises' ? handleDeleteReaction('I surprises') : handleCreateReaction('I surprises')"
      >
        <img src="@/assets/icon_surprises.svg" style="height: 1.6rem" v-if="post.interaction_type === 'I surprises'">
        <img src="@/assets/icon_surprises_outlined.svg" style="height: 1.6rem" v-else>
      </v-btn>

      <span>{{ post.interactions.find(i => i.name === 'I surprises').total }}</span>
    </v-flex>
  </v-card>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    post: { type: Object, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions("posts", ["createLike", "deleteLike"]),
    ...mapMutations("posts", ["setLiked"]),
    async handleCreateReaction(type) {
      this.loading = true 
      const data = await this.createLike({ slug: this.post.slug, type })
      if (data.success) {
        if (this.post.interaction_id) this.setLiked({ interactionType: null, interactionId: null, value: -1, type: this.post.interaction_type })
        this.setLiked({ interactionType: type, interactionId: data.id, value: 1, type })
        
      }
      this.loading = false
    },
    async handleDeleteReaction(type = null) {
      this.loading = true
      const success = await this.deleteLike({ slug: this.post.slug, likeId: this.post.interaction_id })
      if (success) this.setLiked({ interactionType: null, interactionId: null, value: -1, type })
      this.loading = false
    }
  },
}
</script>
<style lang="css" scoped>
.icons-color-reactions{
 filter: invert(65%) sepia(74%) saturate(0%) hue-rotate(189deg) brightness(97%) contrast(102%);
 width: 24px;
}
</style>